import { Button } from '@/components/ui/button';
import { Calendar } from 'lucide-react';
import { scrollToSection } from '@/lib/scroll';

const HeroSection = () => {
  return (
    <section className="md:h-1/2-screen bg-tifpa-hero overflow-hidden">
      <div className="container mx-auto pt-24 lg:pt-40 lg:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-center">
          {/* Left Side: Text Content & CTA */}
          <div className="space-y-2 md:space-y-6 max-w-xl lg:col-span-2">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-stone-800 tracking-tight leading-tighter">
              Trusted <span className="text-tifpa-rose">Tax Solutions</span> for
              Our Community
            </h1>
            <p className="font-sans text-lg text-stone-800">
              Specialized accounting services for small businesses and
              contractors, with a commitment to your financial success.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-6 md:pt-0 justify-center md:justify-start">
              <Button
                className="btn-primary w-full sm:w-auto"
                onClick={() => scrollToSection('consultation')}
              >
                Book a Consultation
                <Calendar className="w-4 h-4" />
              </Button>
            </div>
          </div>
          <div className="relative flex justify-center lg:col-span-1"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
